import axios from 'axios';

const API_URL = process.env.API_URL;

export async function getListTransactions(authorization,filter) {
  const url = `${API_URL}/webclient/account/transaction-history`;
  return axios({
    url,
    method: 'get',
    params: filter,
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function getListContentPurchase(authorization,filter) {
  const url = `${API_URL}/webclient/account/content-purchase`;
  return axios({
    url,
    method: 'get',
    params: filter,
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export function downloadSong(authorization,id){
  const url = `${API_URL}/webclient/account/download/${id}`;
  return axios.get(url, {
    responseType: 'blob',
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    }
  })
}



// WEBPACK FOOTER //
// ./src/services/transactions.js